<div class="bkg-gray ">

  <ion-list>
    <ion-list-header>
      <div class="w-100 d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <ion-checkbox style="margin-right:8px;" [(ngModel)]="allSelected" (ionChange)="toggleSelectAll()"></ion-checkbox>
          <ion-icon name="time-outline"></ion-icon>
          &nbsp;
          <ion-label>Historial</ion-label>
        </div>


        <div>
        <ion-button size="small" fill="clear" [disabled]="getSelectedConversations().length == 0"
         (click)="deleteSelectedConversations()">
          <ion-icon name="trash-outline"></ion-icon>
        </ion-button>

        <ion-button fill="clear"  size="small"  (click)="openSettingsModal()">
          <ion-icon name="settings-outline"></ion-icon>
        </ion-button>
        </div>

      </div>


    </ion-list-header>
    <div class="divider mx-2"></div>

    <ng-container *ngFor="let conversation of conversations; let i = index">

      <ion-item button lines="full" class="ion-margin-bottom m-2">
        <ion-checkbox slot="start" [(ngModel)]="conversation.selected" (ionChange)="onSelectConversation(conversation)"></ion-checkbox>
        <div style="width:100%" (click)="selectConversation(conversation)">
          <ion-label class="ion-text-wrap">
            <h2 class="conversation-title" *ngIf="editingId < 0 || editingId !== i ">
              {{ conversation.title }}
            </h2>
            <ion-input *ngIf="editingId == i && editingId > -1" fill="outline" type="text" [(ngModel)]="editingTitle"
              (ionBlur)="saveTitle(conversation)" (keydown.enter)="saveTitle(conversation)"
              (click)="$event.stopPropagation()" (keydown.escape)="cancelEditing()">
            </ion-input>
            <p>{{ conversation.lastMessage | truncate: 30 }}</p>
          </ion-label>
        </div>
        <ion-button (click)="$event.stopPropagation()" [id]="'click-trigger' + i" size="small" fill="clear" slot="end">
          <ion-icon slot="icon-only" name="ellipsis-vertical-outline"></ion-icon>
        </ion-button>
      </ion-item>

      <ion-popover showBackdrop="false" [trigger]="'click-trigger' + i" triggerAction="click" [dismissOnSelect]="true">
        <ng-template>

          <ion-button fill="clear" expand="full" (click)="enableEditing(conversation, i, $event)">
            <ion-label slot="start">Editar</ion-label>
            <ion-icon size="small" slot="end" name="create-outline"></ion-icon>
          </ion-button>
          <ion-button fill="clear" expand="full" (click)="showDeleteAlert(conversation)">
            <ion-label slot="start" color="danger">Eliminar</ion-label>
            <ion-icon color="danger" size="small" slot="end" name="trash-outline"></ion-icon>
          </ion-button>



        </ng-template>
      </ion-popover>

    </ng-container>

  </ion-list>
</div>